module.exports = __webpack_public_path__ + "static/media/sell_change_request_6.57d12f41.png";